import { axiosAuth } from './axiosInstances'
// KHAN-123: moment esta en modo mantenimiento; dayjs cubre `.format()` con
// el mismo formato ISO-8601 con offset por defecto.
const dayjs = require('dayjs')

// KHAN-231: REST/Django naming standardization. El backend paso de
// api/GroupsCreate/{new_group/, listedCreateby/<id>, delete_groups/}
// (verbos en el path, delete_groups/ era POST) a un unico recurso REST
// api/groups/ + metodo HTTP:
//   POST   api/groups/                  (antes new_group/)
//   GET    api/groups/?created-by=<id>  (antes listedCreateby/<id>)
//   DELETE api/groups/<id>/             (antes POST delete_groups/ con
//                                        {idgroup} en el body)
// Se preservan los nombres de las funciones exportadas y sus parametros
// para no tocar a los consumidores (Group.jsx, GroupBuilder.jsx,
// ListGroups.jsx). createdby/createdat siguen viajando en el body de
// newGroup por compatibilidad con dateFormat.test.js -- el backend los
// ignora igual que antes (createdby siempre sale del token, createdat
// siempre es la hora del servidor).
export async function newGroup(name, image, createdby, isactive) {
  return axiosAuth().post('groups/', {
    name: name,
    idimage: image,
    createdby: createdby,
    createdat: dayjs().format(),
    isactive: isactive,
  })
}

export async function listedCreatedBy(id) {
  return axiosAuth().get('groups/?created-by=' + id)
}

export async function deleteGroup(idgroup) {
  return axiosAuth().delete('groups/' + idgroup + '/')
}
